export default [
    {
        path: 'tecnicos',
        component: require('./Read').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminTecnicoController'
        }
    },
    {
        path: 'tecnicos/add',
        component: require('./Add').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminTecnicoController'
        }
    },
    {
        path: 'tecnicos/edit/:id',
        component: require('./Edit').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminTecnicoController'
        }
    },
    {
        path: 'relatorios/tecnicos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/tecnicos/home',
        meta: { middleware: 'auth', controller: 'RelatorioTecnicoController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_tecnicos',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioTecnicoController' },
        }, {
            path: 'graficos',
            name: 'graficos_tecnicos',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioTecnicoController' },
        }
        ]
    }
]
